/**
 * Amplify Auth setup for Cognito.
 *
 * Pulls config from Vite env vars at build time. Production builds inject
 * the prod User Pool / Client; staging builds get the staging pool.
 *
 * Set these in `.env.local` for local dev:
 *   VITE_COGNITO_USER_POOL_ID=us-east-1_xxx
 *   VITE_COGNITO_CLIENT_ID=xxx
 *   VITE_COGNITO_DOMAIN=https://xxx.auth.us-east-1.amazoncognito.com
 */
import { Amplify } from 'aws-amplify';

const POOL_ID = import.meta.env.VITE_COGNITO_USER_POOL_ID as string | undefined;
const CLIENT_ID = import.meta.env.VITE_COGNITO_CLIENT_ID as string | undefined;
const REGION = (import.meta.env.VITE_AWS_REGION as string | undefined) ?? 'us-east-1';

let configured = false;

export function configureAmplify() {
  if (configured) return;
  if (!POOL_ID || !CLIENT_ID) {
    console.warn(
      '[auth] Cognito env vars not set — auth will not work. Set VITE_COGNITO_USER_POOL_ID and VITE_COGNITO_CLIENT_ID in .env.local.',
    );
    return;
  }
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: POOL_ID,
        userPoolClientId: CLIENT_ID,
        loginWith: { email: true },
        signUpVerificationMethod: 'code',
        userAttributes: { email: { required: true } },
        passwordFormat: {
          minLength: 12,
          requireLowercase: true,
          requireUppercase: true,
          requireNumbers: true,
          requireSpecialCharacters: true,
        },
      },
    },
  });
  configured = true;
}

export const cognitoConfig = {
  region: REGION,
  poolId: POOL_ID,
  clientId: CLIENT_ID,
};
